<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="compendiumShortTermRentalJoins" [lazy]="true" class="Compendium-wrapper" (onLazyLoad)="loadLazy($event)" dataKey="compendiumShortTermRentalJoinId" selectionMode="single"
  [(selection)]="compendiumShortTermRentalJoin" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h3 style="float: left;margin: 6px;">Compendium ShortTermRental Join</h3>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        @if (!outlineNewButton) {
          <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New Compendium ShortTerm Rental Join +</button>
        }
        @if (outlineNewButton) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New Compendium ShortTermRental Join +</button>
        }
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': '110px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'CompendiumVO.name', 'in')"></th>
        <th [ngStyle]="{'width': '180px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'ShortTermRentalVO.propertyCode', 'in')"></th>
        <th [ngStyle]="{'width': '120px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'ShortTermRentalVO.bedrooms', 'in')"></th>
        <th [ngStyle]="{'width': '120px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'ShortTermRentalVO.addressCounty', 'in')"></th>
        <th [ngStyle]="{'width': '120px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'ShortTermRentalVO.addressState', 'in')"></th>
        <th [ngStyle]="{'width': '90px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'status', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-compendiumShortTermRentalJoin>
    <tr [pSelectableRow]="compendiumShortTermRentalJoin">
      <td>{{compendiumShortTermRentalJoin?.compendium.name}} </td>
      <td>{{compendiumShortTermRentalJoin?.propertyCode}}</td>
      <td>{{compendiumShortTermRentalJoin?.bedroomNum}}</td>
      <td>{{compendiumShortTermRentalJoin?.adrCounty}}</td>
      <td>{{compendiumShortTermRentalJoin?.adrState}}</td>
      <td>{{getStatusName(compendiumShortTermRentalJoin)}}</td>
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(compendiumShortTermRentalJoin)"></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>